import React from 'react';
import { Alert, Chip, Paper, Stack, Typography } from '@mui/material';

const formatTimestamp = (value) => {
  if (!value) return 'N/A';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleString();
};

const ReportsWarningsPanel = ({ logs }) => {
  return (
    <Paper variant="outlined" sx={{ p: 2, borderRadius: 3 }}>
      <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
        Warnings
      </Typography>
      {logs.length === 0 ? (
        <Alert severity="info">No report warnings have been recorded.</Alert>
      ) : (
        <Stack spacing={1}>
          {logs.map((log) => (
            <Paper key={log.id} variant="outlined" sx={{ p: 1.5, borderRadius: 2 }}>
              <Stack direction={{ xs: 'column', md: 'row' }} spacing={1} alignItems={{ md: 'center' }}>
                <Chip
                  size="small"
                  label={log.level || 'warning'}
                  color={log.level === 'error' ? 'error' : 'warning'}
                  sx={{ textTransform: 'capitalize' }}
                />
                <Typography variant="body2" sx={{ flex: 1, fontWeight: 600 }}>
                  {log.event || 'reports.warning'}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  {formatTimestamp(log.createdAt)}
                </Typography>
              </Stack>
              <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                {log.message || 'No message provided.'}
              </Typography>
            </Paper>
          ))}
        </Stack>
      )}
    </Paper>
  );
};

export default ReportsWarningsPanel;
